import {
  FlyerDetailPageFormPositionCategoriesActions,
  FlyerDetailPageFormPositionCategoriesActionType,
} from "./flyer-detail-page-form-position-categories.actions";
import { PositionCategoriesState } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";
import { flyerDetailPageFormPositionCategoriesState } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.functions";

export function flyerDetailPageFormPositionCategoriesReducer(
  state = flyerDetailPageFormPositionCategoriesState(),
  action: FlyerDetailPageFormPositionCategoriesActionType
): PositionCategoriesState {
  switch (action.type) {
    case FlyerDetailPageFormPositionCategoriesActions.ClearCategoryResults:
      return flyerDetailPageFormPositionCategoriesState();

    case FlyerDetailPageFormPositionCategoriesActions.SearchCategory:
      return {
        ...state,
        loading: true,
      };

    case FlyerDetailPageFormPositionCategoriesActions.SearchCategoryFailure:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case FlyerDetailPageFormPositionCategoriesActions.SearchCategorySuccess:
      return {
        ...state,
        categories: action.payload,
        loading: true,
      };

    default:
      return state;
  }
}
